export default {
  // Tabs
  tabUsers: 'Usuários',
  tabReferences: 'Referências',
  tabEkrm: 'EKRM',
  tabRoles: 'Papéis',
  tabGroups: 'Grupos',
  tabAuditTrail: 'Trilha de Auditoria',

  // Users tab - toolbar
  saveChanges: 'Salvar Alterações',
  cancel: 'Cancelar',
  unsavedChanges: '{count} alterações não salvas',
  search: 'Buscar',

  // Users tab - table headers
  headerEmail: 'E-mail',
  headerModels: 'Modelos',
  headerActions: 'Ações',

  // Users tab - models
  selectModels: 'Selecionar Modelos',
  pending: 'Pendente',

  // Users tab - delete dialog
  deleteUserTooltip: 'Excluir Usuário',
  deleteDialogTitle: 'Aviso',
  deleteDialogText: 'Excluindo usuário: {userName}',
  deleteDialogConfirmation: 'Esta ação não pode ser desfeita. Tem certeza?',
  deleteButton: 'Excluir',
  deleting: 'Excluindo...',

  // Alert messages
  alertClose: 'Fechar',
  saveSuccessMessage: 'Alterações salvas com sucesso para {count} usuário(s)',
  saveErrorMessage: 'Erro ao salvar as alterações. Por favor, tente novamente.',
  saveErrorWithDetails: 'Ocorreu um erro ao salvar as alterações: {error}',
  cancelledMessage: 'Alterações canceladas',
  deleteSuccessMessage: 'Usuário {userName} excluído com sucesso',
  deleteErrorMessage: 'Erro ao excluir usuário: {error}',
  loadErrorMessage: 'Erro ao carregar os dados. Por favor, atualize a página ou entre em contato com o suporte se o problema persistir.'
}
